import { ReportFilters } from '../components/ReportFilters';
import { ReportSummaryCards } from '../components/ReportSummaryCards';
import { ReportDetailTable } from '../components/ReportDetailTable';
import { Box, Button } from '@mui/material';

export default function ReportListPage() {
  return (
      <Box sx={{ p: { xs: 1, md: 4 }, background: '#F6F8FB', minHeight: '100vh' }}>
        <ReportFilters />
        <ReportSummaryCards />
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button variant="contained" color="primary">Exportar PDF</Button>
        </Box>
        <ReportDetailTable />
      </Box>
  );
}
